<template>
  <div class="Container">
    <div @click="$router.push({ name: 'qrcode' })" class="qrcodeBtn" v-if="$mq !== 'desktop'">
      <img src="@/assets/qrcodelogo.png" />
    </div>
    <div
      @click="$router.push({ name: 'geoloc' })"
      class="geolocBtn"
      v-if="$mq !== 'desktop' && showGeoloc"
    >
      <img src="@/assets/geoloclogo.png" />
    </div>
    <span v-if="label" class="Label">{{ label }}</span>
    <div :class="['Switch-Container', isActive, isBig]" @click="$emit('input', !value)">
      <div v-if="disabled" class="Overlay" @click.stop />
      <div :class="knobClasses" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'VvSwitch',
  props: {
    value: Boolean,
    label: String,
    disabled: Boolean,
    big: Boolean,
    showGeoloc: Boolean
  },
  computed: {
    isActive() {
      return this.value ? 'Active' : ''
    },
    isBig() {
      return this.big ? 'Big' : ''
    },
    knobClasses() {
      return this.value ? ['Knob', 'Active'] : 'Knob'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.qrcodeBtn {
  height: 35px;
  padding: 8px;
  margin: 5px;
  border-radius: 50px;
  img {
    height: 100%;
    width: 100%;
  }
  cursor: pointer;
}
.geolocBtn {
  height: 40px;
  padding: 5px 12px;
  margin: 5px;
  border-radius: 50px;
  img {
    height: 100%;
    width: 100%;
  }
  cursor: pointer;
}
.Container {
  display: flex;
  flex-direction: row;
  align-items: center;

  .Label {
    margin-right: 15px;
  }

  .Switch-Container {
    cursor: pointer;
    position: relative;
    z-index: 2;
    height: 24px;
    width: 44px;
    background-color: #c7c7c7;
    border-radius: 12px;
    transition: all 150ms linear;
    overflow: hidden;

    &.Active {
      background-color: $primary;
    }

    &.Big {
      height: 30px;
      width: 50px;
      border-radius: 20px;

      .Knob {
        height: 25px;
        width: 25px;
      }
    }

    .Overlay {
      position: absolute;
      z-index: 5;
      background-color: white;
      opacity: 0.5;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    }

    .Knob {
      position: absolute;
      height: 20px;
      width: 20px;
      border-radius: 20px;
      top: 2.1px;
      left: 3px;
      background-color: white;
      transition: all 150ms linear;

      &.Active {
        transform: translateX(20px);
      }
    }
  }
}
</style>
